import {openResourceModal} from '../../core/modalCommand';
import {CLIENT_DISCONNECT_MODAL_EVENT} from './events';

/**
 * Open the Disconnect Client confirmation for one client.
 *
 * Canvas owns the confirmation and owns the refusal inside it: a client on a
 * TIP access point cannot be disconnected, and the page says so itself. This
 * opens the dialog and stops - nothing leaves the network until the person
 * presses the button in it.
 *
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openClientDisconnectModal(command, envelope) {
	return openResourceModal(CLIENT_DISCONNECT_MODAL_EVENT, command, envelope);
}
